<div
  class="py-[0.25rem] self-stretch rounded-02 bg-[#F5F5F5] px-[0.25rem]"
  data-cy="header-container"
>
  <div class="flex justify-center items-start gap-1">
    <span class="text-[#161B38] text-body-xs text-left" data-cy="header-title">
      {{ content.title }}
    </span>
    <div
      *ngIf="content.action; else default"
      class="flex items-start whitespace-nowrap"
      data-cy="header-action-container"
    >
      <span class="text-[#161B38] text-body-xs">:</span>
      <a
        class="link link-sm text-[#06C] text-label-spaced-xs-medium pl-[3px] [text-wrap:auto] mt-[2px]"
        (click)="onLinkClick($event)"
        data-cy="header-action-link"
        [attr.data-acdl-action]="
          'skymiles flyout:' +
          content.action.label.toLocaleLowerCase() +
          ':link'
        "
        [attr.data-acdl-name]="content.action.label.toLocaleLowerCase()"
        data-acdl-page-section="header:skymiles flyout"
        href="{{ content.action.url }}"
      >
        {{ content.action.label }}
      </a>
    </div>
    <ng-template #default>
      <div
        class="link link-sm text-[#06C] text-label-spaced-xs-medium"
        data-cy="header-subtitle"
      >
        {{ content.subtitle }}
      </div>
    </ng-template>
  </div>
</div>
